<mat-sidenav-container>
  <mat-sidenav disableClose #sidenav mode="side" opened [class.collapsed]="isSideNavCollapsed()"
    ><nav-sidebar-content [(isCollapsed)]="isSideNavCollapsed"
  /></mat-sidenav>

  <mat-sidenav-content [class.collapsed]="isSideNavCollapsed()">
    <div id="main-content-container"><router-outlet /></div>
    <app-footer />
  </mat-sidenav-content>
</mat-sidenav-container>

<need-help-modal [open]="needHelp.show()" (closeModal)="needHelp.close()" />
